import styled from "styled-components";
import { Button } from "rebass";

export const EntryButtonStyled = styled(Button)`
  padding: 0;
  background-color: transparent;
  transition: .4s all;

  & + & {
    margin-top: 1px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors["sp-gray2"]};
  }

  &:disabled {
    background-color: #eee;
    cursor: not-allowed;
  }
`;
